import {
  ADMIN_LOGIN,
  Button,
  Div,
  H3,
  LogoutIcon,
  Modal,
  P,
  signOut,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

export const AdminLogoutModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  // Through ThemeProvider so a navy-primary app (deliveries) gets its own
  // disc; admin's theme.primary is the red this icon always carried.
  const theme = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  /**
   * Awaited rather than fired and forgotten: `signOut` tells the backend to
   * drop THIS device's push token, and that call has to complete while the
   * access token is still around. The button is disabled meanwhile so a second
   * click can't send it twice.
   */
  const handleLogout = async () => {
    if (loading) return;
    setLoading(true);
    await signOut('logout modal');
    navigate(ADMIN_LOGIN);
  };

  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      logo={false}
      exitButton={false}
    >
      <Div $mb="16">
        <LogoutIcon color={theme.primary} />
      </Div>

      <H3 $m="10px" $center>
        Logout
      </H3>
      <P $mb="24" $center>
        Are you sure you want to logout?
      </P>

      <Div $flex $gap="16px">
        <Button
          onClick={handleLogout}
          disabled={loading}
          $w="100%"
          $selected
        >
          Yes
        </Button>
        <Button $w="100%" onClick={() => setIsOpen(false)} $gray $selected>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
